import type { ReactNode } from 'react';

import {
  type FieldValues,
  type UseControllerProps,
  useController,
} from 'react-hook-form';

import { Checkbox } from '@pulse-web-ui/checkbox';

import { addTestAttribute } from '@shared/index';

type Props<T extends FieldValues> = UseControllerProps<T> & {
  label: string | ReactNode;
  id?: string;
  onChange?: (val: boolean) => void;
  testId?: string;
};

export const CheckboxController = <T extends FieldValues>({
  label,
  onChange,
  testId = 'checkbox',
  id,
  disabled,
  ...controllerProps
}: Props<T>) => {
  const { field, fieldState } = useController(controllerProps);

  return (
    <Checkbox
      checked={field.value}
      onChange={(val) => {
        field.onChange(val.target.checked);
        onChange && onChange(val.target.checked);
      }}
      id={id}
      label={label}
      status={!!fieldState.error ? 'error' : undefined}
      message={fieldState.error?.message}
      disabled={disabled}
      {...addTestAttribute(testId)}
    />
  );
};
